
import { INavLink, INavLinkGroup, INavStyles, Nav, Stack } from '@fluentui/react';
import * as React from 'react';
import { connect } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { IUserProfile } from '../../Models/Profile/IUserProfile';
import { IAppStore } from '../../Stores/IAppStore';

interface IMenuViewProps {
    profile: IUserProfile;
}

const navStyles: Partial<INavStyles> = {
    root: {
        width: 180,
        boxSizing: 'border-box',
        border: '0px solid #eee',
        overflowY: 'auto',

    },
    link: {
        whiteSpace: 'normal',
        lineHeight: 'inherit',
    },
    groupContent: {
        paddingBottom: 0,
        marginBottom: 0
    }
};


export const MenuView: React.FunctionComponent<IMenuViewProps> = (props) => {

    const [navLinks, setNavLink] = React.useState<INavLinkGroup[]>([])
    const navigate = useNavigate();

    const linkClick = (e?: React.MouseEvent<HTMLElement>, item?: INavLink) => {
        e?.preventDefault();
        item?.url && navigate(item?.url);
        if (item) {
            //item..isExpanded = true;
        }
    }

    const navLinkGroups: INavLinkGroup[] = [
        {
            name: 'Účet',
            expandAriaLabel: 'Rozbalí nabídku účtu',
            collapseAriaLabel: 'Zbalí nabídku účtu',
            collapseByDefault: (props.profile.isAdmin || props.profile.isAccountant || props.profile.isTeacher),
            links: [
                {
                    key: 'Moje kurzy',
                    name: 'Moje kurzy',
                    url: '/portal/events/myEvents',
                    onClick: linkClick,
                },
                {
                    key: 'Moje objednáky',
                    name: 'Moje objednáky',
                    url: '/portal/orders/myOrders',
                    onClick: linkClick,
                },
                {
                    key: 'Moje faktury',
                    name: 'Moje faktury',
                    url: '/portal/invoices/myInvoices',
                    onClick: linkClick
                }
            ],
            
        },
        {
            name: 'Profil',
            collapseByDefault:true,
            links: [
                {
                    key: 'Fakturační údaje',
                    name: 'Fakturační údaje',
                    url: '/portal/identity/invoiceContact',
                    onClick: linkClick
                },
                {
                    key: 'Změna emailu',
                    name: 'Změna emailu',
                    url: '/portal/identity/emailChange',
                    onClick: linkClick
                },
                {
                    key: 'Změna hesla',
                    name: 'Změna hesla',
                    url: '/portal/identity/password',
                    onClick: linkClick
                },
            ],
        },
    ];

    const addUserAdmin = (): INavLinkGroup => {
        
        const group: INavLinkGroup={
            name: 'Uživatelé',
                links: [
                    {
                        key: 'Registrovaní uživatelé',
                        name: 'Registrovaní uživatelé',
                        title: 'Registrovaní uživatelé',
                        url: '/portal/admin/Users',
                        onClick: linkClick,
                    },
                    {
                        key: 'Účastníci',
                        name: 'Účastníci',
                        title: 'Účastníci',
                        url: '/portal/admin/FindAttendee',
                        onClick: linkClick,
                    },
                    {
                        key: 'Objednávky',
                        name: 'Objednávky',
                        url: '/portal/orders/admin',
                        onClick: linkClick
                    },
                ],
        }
        return group;
    }

    const addEventAdmin = () => {

        const group: INavLinkGroup = {
            name: 'Nastavení akcí',
            collapseByDefault: true,
            links: [
                {
                    key: 'Akce',
                    name: 'Akce',
                    url: '/portal/admin/Events',
                    onClick: linkClick
                },
                {
                    key: 'Typy akcí',
                    name: 'Typy akcí',
                    url: '/portal/admin/EventTypes',
                    onClick: linkClick
                },
                {
                    key: 'Místa konání akcí',
                    name: 'Místa konání akcí',
                    url: '/portal/admin/Rooms',
                    onClick: linkClick
                },
                {
                    key: 'Věkové skupiny',
                    name: 'Věkové skupiny',
                    url: '/portal/admin/AgeGroups',
                    onClick: linkClick
                },
            ],
        }
        return group;
    }
    const addPhotogalleryAdmin = () => {
        const group: INavLinkGroup = {
            name: 'Photogallery',
            collapseByDefault: true,
            links: [
                {
                    key: 'Fotogalerie',
                    name: 'Fotogalerie',
                    url: '/portal/Fotogalerie/admin',
                    onClick: linkClick
                }]
        }
        return group;
    }

    const addAccountantAdmin = () => {
        const group: INavLinkGroup = {
            name: 'Účetnictví',
            collapseByDefault: true,
            links: [
                {
                    key: 'Faktury',
                    name: 'Faktury',
                    url: '/portal/admin/invoices/list',
                    onClick: linkClick
                },
                {
                    key: 'Platby',
                    name: 'Platby',
                    url: '/portal/admin/payments/list',
                    onClick: linkClick
                },
                {
                    key: 'KontaktniInformace',
                    name: 'Kontaktní informace',
                    url: '/portal/admin/contactInfo',
                    onClick: linkClick
                },
                {
                    key: 'Texty',

                    name: 'Texty',
                    url: '/portal/admin/texts',
                    onClick: linkClick
                },
            ],
        }
        return group;

    }

    const addTeacher = () => {
        const group: INavLinkGroup = {
            name: 'Kde učím',
            links: [
                {
                    key: 'AkceTeacher',
                    name: 'Akce',
                    url: '/portal/teacher/Events',
                    onClick: linkClick
                }                
            ],
        }
        return group;
    }

    const reports = () => {
        const group: INavLinkGroup = {
            name: 'Reporty',
            links: [],
            collapseByDefault: true
        }

        if (props.profile.isAdmin) {
            group.links=group.links.concat(addReportAdmin());
        }
        if (props.profile.isAccountant) {
            group.links=group.links.concat(addReportAccountant());
        }
        return group;
    }

    const addReportAdmin = () => {
        const links: INavLink[] = [
            {
                key: 'OduceneLekce',
                name: 'Odučené lekce',
                url: '/portal/report/EventLessonsProgress',
                onClick: linkClick
            }
        ];        
        return links;
    }

    const addReportAccountant = () => {
        const links: INavLink[] = [
            {
                key: 'OdmenyLektoru',
                name: 'Odměny lektoru',
                url: '/portal/report/TeacherLessonsByMonth',
                onClick: linkClick
            }
        ];
        return links;
    }


    React.useEffect(() => {
        if (props.profile) {
            if (props.profile.isTeacher) {
                navLinkGroups.push(addTeacher())
            }
            if (props.profile.isAdmin) {
                navLinkGroups.push(addUserAdmin());
            }            
            if (props.profile.isAdmin) {
                navLinkGroups.push(addEventAdmin());
                navLinkGroups.push(addPhotogalleryAdmin());
            }
            if (props.profile.isAccountant) {
                navLinkGroups.push(addAccountantAdmin());
            }
            navLinkGroups.push(reports());
            setNavLink(navLinkGroups);
        }
    }, [props.profile])

    return (<Stack>

        {props.profile.id!=="" ?
            <Stack>
                <Nav styles={navStyles}
                    ariaLabel="Nav example similar to one found in this demo page"
                    groups={navLinks} />
            </Stack> : null}

    </Stack>)
}

const EmailChangeToProps = (state: IAppStore) => ({
    profile: state.userProfileStore.profile,

});

const EmailChangeDispatchToProps = (dispatch: ThunkDispatch<IAppStore, any, AnyAction>) => ({

});

export default connect(EmailChangeToProps, EmailChangeDispatchToProps)(MenuView);


